/* 
▗▖  ▗▖▗▖ ▗▖▗▄▄▄▖▗▄▄▄▖▗▖  ▗▖ ▗▄▖     ▗▄▄▄▖▗▖ ▗▖▗▄▄▄▖▗▖  ▗▖▗▄▄▄▖    ▗▄▄▖ ▗▖ ▗▖▗▄▄▄▖▗▖   ▗▄▄▄ ▗▄▄▄▖▗▄▄▖ 
▐▛▚▖▐▌▐▌ ▐▌  █    █  ▐▛▚▞▜▌▐▌ ▐▌      █  ▐▌ ▐▌▐▌   ▐▛▚▞▜▌▐▌       ▐▌ ▐▌▐▌ ▐▌  █  ▐▌   ▐▌  █▐▌   ▐▌ ▐▌
▐▌ ▝▜▌▐▌ ▐▌  █    █  ▐▌  ▐▌▐▛▀▜▌      █  ▐▛▀▜▌▐▛▀▀▘▐▌  ▐▌▐▛▀▀▘    ▐▛▀▚▖▐▌ ▐▌  █  ▐▌   ▐▌  █▐▛▀▀▘▐▛▀▚▖
▐▌  ▐▌▝▚▄▞▘  █  ▗▄█▄▖▐▌  ▐▌▐▌ ▐▌      █  ▐▌ ▐▌▐▙▄▄▖▐▌  ▐▌▐▙▄▄▖    ▐▙▄▞▘▝▚▄▞▘▗▄█▄▖▐▙▄▄▖▐▙▄▄▀▐▙▄▄▖▐▌ ▐▌
  
* NUTIMA THEME BUILDER
* Shopify Theme Compiler & Generator powered by nutima
* 
* Copyright (c) 2025 nutima
* All rights reserved.
* 
* ⚠️  WARNING: This file is auto-generated by Nutima Theme Builder
* ⚠️  DO NOT EDIT this file manually - your changes will be overwritten
* ⚠️  To make changes, edit the source files and rebuild the theme
* 
* Version: 1.0.0
* Build: Production
* 
* For support: support@nutima.agency
* Website: https://nutima.agency
 */
/* 
▗▖  ▗▖▗▖ ▗▖▗▄▄▄▖▗▄▄▄▖▗▖  ▗▖ ▗▄▖     ▗▄▄▄▖▗▖ ▗▖▗▄▄▄▖▗▖  ▗▖▗▄▄▄▖    ▗▄▄▖ ▗▖ ▗▖▗▄▄▄▖▗▖   ▗▄▄▄ ▗▄▄▄▖▗▄▄▖ 
▐▛▚▖▐▌▐▌ ▐▌  █    █  ▐▛▚▞▜▌▐▌ ▐▌      █  ▐▌ ▐▌▐▌   ▐▛▚▞▜▌▐▌       ▐▌ ▐▌▐▌ ▐▌  █  ▐▌   ▐▌  █▐▌   ▐▌ ▐▌
▐▌ ▝▜▌▐▌ ▐▌  █    █  ▐▌  ▐▌▐▛▀▜▌      █  ▐▛▀▜▌▐▛▀▀▘▐▌  ▐▌▐▛▀▀▘    ▐▛▀▚▖▐▌ ▐▌  █  ▐▌   ▐▌  █▐▛▀▀▘▐▛▀▚▖
▐▌  ▐▌▝▚▄▞▘  █  ▗▄█▄▖▐▌  ▐▌▐▌ ▐▌      █  ▐▌ ▐▌▐▙▄▄▖▐▌  ▐▌▐▙▄▄▖    ▐▙▄▞▘▝▚▄▞▘▗▄█▄▖▐▙▄▄▖▐▙▄▄▀▐▙▄▄▖▐▌ ▐▌
  
* NUTIMA THEME BUILDER
* Shopify Theme Compiler & Generator powered by nutima
* 
* Copyright (c) 2025 nutima
* All rights reserved.
* 
* ⚠️  WARNING: This file is auto-generated by Nutima Theme Builder
* ⚠️  DO NOT EDIT this file manually - your changes will be overwritten
* ⚠️  To make changes, edit the source files and rebuild the theme
* 
* Version: 1.0.0
* Build: Production
* 
* For support: support@nutima.agency
* Website: https://nutima.agency
 */
class t{constructor(){this.sections=[],this.viewportHeight=window.innerHeight,this.#t()}#t(){"loading"===document.readyState?document.addEventListener("DOMContentLoaded",(()=>this.#i())):this.#i()}#i(){this.sections=Array.from(document.querySelectorAll(".section")),0!==this.sections.length&&this.sections.forEach((t=>{if(t.getBoundingClientRect().top<this.viewportHeight)return;const i=this.#n(t);if(!i)return;const n=this.#s(t);this.#o(t,i,n)}))}#n(t){return Array.from(t.classList).find((t=>!t.includes("section")))||null}#s(t){const i=t.offsetHeight;return Math.max(300,i)}#o(t,i,n){t.style.contentVisibility="auto",t.style.containIntrinsicSize=`0 ${n}px`,t.setAttribute("data-cv-optimized",i)}}new t;